/**! 
 * @license slickgrid-print-plugin v0.1.0
 * Copyright (c) 2013 . 
 * License: MIT
 */
(function ($) {
    'use strict';

    var SlickPrint = function () {

        var _self = this;
        var _grid;

        this.init = function (grid) {
            _grid = grid;
        };

        this.printToHtml = function (selectedOnly) {
            var numRows = _grid.getDataLength();
            var columns = _grid.getColumns().filter(function(col){
                return col.printable;

            });
            var numCols = columns.length;
            var r, c;
            var rows = [], cols = [], headers = [];
            var cellNode;
            var topRow = _grid.getRenderedRange().top;

            var rowSelected;

            columns.forEach(function (col) {
                headers.push(col.name);
            });

            Slick.GlobalEditorLock.cancelCurrentEdit();

            _grid.scrollRowToTop(0);

            for (r = 0; r < numRows; r++) {
                cols = [];
                rowSelected=true;
                for (c = 0; c < numCols; c++) {
                    cellNode = _grid.getCellNode(r, c);

                    if(selectedOnly && cellNode && cellNode.classList && !cellNode.classList.contains("selected")){
                        rowSelected=false;
                        break;
                    }

                    if (!cellNode) {
                        _grid.scrollRowToTop(r);
                        cellNode = _grid.getCellNode(r, c);
                    }
                    cols.push($(cellNode).text());
                }

                if(rowSelected){
                    rows.push('<td>' + cols.join('</td><td>') + '</td>');
                }
            }

            var table = [
                '<table class="print-table">',
                '<thead>',
                '<tr>',
                    '<th>' + headers.join('</th><th>') + '</th>',
                '</tr>',
                '</thead>',
                '<tbody>',
                    '<tr>' + rows.join('</tr>\n<tr>') + '</tr>',
                '</tbody>',
                '</table>'
            ].join('\n');

            _grid.scrollRowToTop(topRow);

            return table;
        };

        this.printToElement = function ($element, selectedOnly) {
            var _dummy = document.createElement('div');
            _dummy.innerHTML = _self.printToHtml(selectedOnly);
            $element.appendChild(_dummy.firstChild);
        };

        this.printToWindow = function (w) {
            w.onload = function () {
                setTimeout(function () {
                    _self.printToElement(w.document.body);
                });
            };
        };

        this.print = function (opts) {

            var _opts = opts || {
                triggerPrintDialog: undefined,
                windowFeatures: undefined,
                cssLinksHtml: undefined,
                title: undefined,
                selectedOnly:undefined
            };


            var win = window.open('', '',
                _opts.windowFeatures || 'width=552,height=477,toolbar=0,scrollbars=0,status=0'
            );

            var content = '<html class="print-html">';
            if (_opts.cssLinksHtml) {
                content += '<head>' + (_opts.cssLinksHtml ? _opts.cssLinksHtml : '') + '</head>';
            }

            if (_opts.triggerPrintDialog) {
                content += "<body class='print-body' onload='window.print(); window.close();'>";
            } else {
                content += "<body class='print-body'>";
            }

            var companyInfo = jQuery('<div>')
                .append(jQuery(window.document.getElementsByClassName("company-info")[0]).clone()).html();

            content += "<div id='header' class='print-header'> " +
                       companyInfo +
                       "<span class='print-header-title'>"+(_opts.title ? _opts.title : '')+"</span>" +
                       "</div>";

            content += "</body>";
            content += "</html>";
            win.document.write(content);
            _self.printToElement(win.document.body, _opts.selectedOnly);
            win.document.close();
        };

    };

    // register namespace
    $.extend(true, window, {
        Slick: {
            Plugins: {
                Print: SlickPrint
            }
        }
    });
}(jQuery));
